// extracted by mini-css-extract-plugin
module.exports = {"jds-MenuTag":"MenuTag_jds-MenuTag__Rju_e"};